export function init() {
    (function (w, d, s, l, i) {
        w[l] = w[l] || []; w[l].push({
            'gtm.start':
                new Date().getTime(), event: 'gtm.js'
        }); var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                'https://www.googletagmanager.com/gtm.js?id=' + i + dl + '&gtm_auth=' + clari_gtm_auth + '&gtm_preview=env-' + clari_gtm_env + '&gtm_cookies_win=x'; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-5MBKXKP');

    var bodyEl = document.getElementsByTagName("body")[0];
    var gtmEl = document.createElement("noscript");

    gtmEl.innerHTML = "<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-5MBKXKP&gtm_auth=" + clari_gtm_auth + "&gtm_preview=env-" + clari_gtm_env + "&gtm_cookies_win=x" + "\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" ></iframe >";

    bodyEl.insertBefore(gtmEl, bodyEl.childNodes[0]);
};